import React from 'react';
import { Modal } from '../Modal/Modal';
import { useTranslation } from 'react-i18next';
import { ReferralProgramContent } from '../ReferralProgram/ReferralProgramDialog';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

function ReferralInviteModal({ isOpen, onClose }: Props) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <Modal
      modalTitle={t("sales.referral_modal.title") || "Invite Producent to eAteliers"}
      canClose
      onClose={onClose}
    >
      <ReferralProgramContent
        isOpen={isOpen}
        subtitleOverride={
          t("sales.referral_modal.message") ||
          "This item belongs to an external producent. Instead of sending one‑off emails, invite them to eAteliers so you both manage catalogues, orders and files in one shared workspace."
        }
        benefitsOverride={[
          t("sales.referral_modal.benefit_collaboration") ||
            "Collaborate in real time on production orders and status updates.",
          t("sales.referral_modal.benefit_automation") ||
            "Keep contracts, orders and attachments automatically organised.",
          t("sales.referral_modal.benefit_reward") ||
            "Share your referral link and earn up to 300 USD when a producent joins.",
        ]}
      />
    </Modal>
  );
}

export default ReferralInviteModal;
